import React, { PureComponent } from 'react';

import { getConfig } from '../utils/configUtils';
import { registerErrorStatusListener } from '../vodjs/ErrorHandling';
import { getObfuscatedRobotSN } from '../vodjs/lib.js';
import { getSession } from '../vodjs/ElasticLog.js';
import { getLoadQueryParams } from '../utils/configUtils';

export default class VersionDisplay extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
      errorStatus: undefined,
    };

    this.summaryVersion = this.details = 'version info not found';
    this.color = '#F00';

    this.color = '#555';

    let v = getConfig().version;

    this.summaryVersion = `${v.branch}/${getConfig().site.name}`;

    this.details = v.time;

    let scrubbedUrl = getLoadQueryParams(true);
    this.details += ' U:' + (scrubbedUrl || '(empty)');

    this.details += ' G:' + v.commit.slice(0, 8); //first 8 digits of the commit hash

    let obfuscatedSN = getObfuscatedRobotSN();
    if (obfuscatedSN) this.details += ' DWRF:' + obfuscatedSN;

    if (v.modCount) this.details += ` M:${v.modCount}`;

    let session = getSession();
    if (session) this.details += ' S:' + session.split('-').pop();
  }

  componentDidMount() {
    this.unregErrorListener = registerErrorStatusListener((errorStatus) => this.setState({ errorStatus }));
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }
    if (this.unregErrorListener) this.unregErrorListener();
  }

  toggleDetails() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }

    let showDetails = !this.state.showDetails;
    this.setState({ showDetails });
    if (showDetails) this.timeout = setTimeout(() => this.setState({ showDetails: false }), 10 * 1000);
  }

  versionElement() {
    let versionStr = this.state.showDetails ? this.details : this.summaryVersion;
    if (this.state.errorStatus && this.state.showDetails)
      versionStr += '\n' + this.state.errorStatus.errStrings.join('\n');
    let style = {
      textAlign: 'center',
      color: this.state.errorStatus ? '#F00' : this.color,
      fontWeight: 800,
      fontSize: 16,
      fontWeight: 'bold',
    };

    return (
      <div
        style={{
          height: 20,
          marginBottom: 7,
          marginTop: 7,
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          alignItems: 'center',
        }}
      >
        <div style={{ flex: 1, height: 1 }} />
        <div style={style} id={'page_version'} alt={'Page Version'} onClick={() => this.toggleDetails()}>
          {versionStr}
        </div>
        <div style={{ flex: 1, height: 1 }} />
      </div>
    );
  }

  render() {
    // if(enableDebugging && this.state.showDetails)
    //   return <DebugDisplay dismiss={() => this.toggleDetails()}/>;  //show debug display
    // else
    return this.versionElement(); //show version display as normal
  }
}
